import React from 'react';

const Error = () => {
  return (
    <div style={{ padding: 32 }}>
      <div style={{
        maxWidth: 360, background: '#fff',
        border: '1px solid #e5e7eb', borderRadius: 6,
        padding: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      }}>
        <h6 style={{ margin: '0 0 12px', fontSize: 16, fontWeight: 600 }}>
          <strong style={{ color: 'red' }}>ERRO 404</strong> - Página não encontrada
        </h6>
        <p style={{ margin: 0, color: '#64748b', fontSize: 14 }}>
          Por favor, verifique a URL informada ou entre em contato com o administrador do site.
        </p>
      </div>
    </div>
  );
};

export default Error;
